import React, { useState } from 'react';
import { Users, UserCog, Download, RefreshCw } from 'lucide-react';
import UsersTab from '../components/admin/UsersTab';
import TeamTab from '../components/admin/TeamTab';

const UserManagement = () => {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-purple-50 to-blue-50 p-6">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-8">
        <div
          className="relative overflow-hidden rounded-3xl p-8 backdrop-blur-xl"
          style={{
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.8) 100%)',
            border: '1px solid rgba(255, 182, 193, 0.3)',
          }}
        >
          <h1 className="text-4xl font-bold bg-gradient-to-r from-rose-500 via-purple-500 to-pink-600 bg-clip-text text-transparent mb-2">
            User Management
          </h1>
          <p className="text-gray-600">Manage app users and team members</p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="max-w-7xl mx-auto mb-6">
        <div
          className="inline-flex rounded-2xl p-1 backdrop-blur-xl"
          style={{
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.5) 100%)',
            border: '1px solid rgba(255, 182, 193, 0.2)',
          }}
        >
          <button
            onClick={() => setActiveTab('users')}
            className={`flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
              activeTab === 'users'
                ? 'bg-gradient-to-r from-rose-400 to-pink-500 text-white shadow-lg'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <Users className="w-5 h-5" />
            <span>Users</span>
          </button>
          <button
            onClick={() => setActiveTab('team')}
            className={`flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
              activeTab === 'team'
                ? 'bg-gradient-to-r from-purple-400 to-violet-500 text-white shadow-lg'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <UserCog className="w-5 h-5" />
            <span>Team</span>
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="max-w-7xl mx-auto">
        {activeTab === 'users' ? <UsersTab /> : <TeamTab />}
      </div>
    </div>
  );
};

export default UserManagement;
